<template>
  <section class="case" name="case">
    <div class="container">
      <a-typography-title :level="1">
        商业化方案
      </a-typography-title>
      <a-row :gutter="[20,$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)?50:20]">
        <a-col v-for="(item,index) in expand.case"
               :xs="24" :md="12" :xl="8">
          <div class="item" :class="`i_${index+1}`">
            <div class="image">
              <img alt=""
                   :src="item.image" />
            </div>
            <a-typography-title :level="5">
              {{ item.title }}
            </a-typography-title>
            <!--<a-typography-paragraph>-->
            <!--  {{ item.text }}-->
            <!--</a-typography-paragraph>-->
            <div class="list">
              <p v-for="v in item.list">
                {{ v }}
              </p>
            </div>
            <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
              <a-button type="link" class="button_n_3"
                        @click="item.btn.click">
                {{ item.btn.name }}
              </a-button>
            </a-space>
          </div>
        </a-col>
      </a-row>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import Image_1 from '@resource/image/page/home/case_image_1.png';
import Image_2 from '@resource/image/page/home/case_image_2.png';
import Image_3 from '@resource/image/page/home/case_image_3.png';

export default {
  name: 'home_case',
  data(): DataInterface {
    return {
      expand: {
        case: [
          {
            title: '私有化部署版',
            text: '',
            list: [
              'AIPilot软件单机版',
              'AIPilot软件集群版',
              '大模型套餐包'
            ],
            image: Image_1,
            btn: {
              name: '免费部署',
              click: () => {
                // location.href = 'https://galaxy-future.feishu.cn/docx/BpfYdxcOYoNbXYxEHk8ce0OHnLd';
                open('https://galaxy-future.feishu.cn/docx/BpfYdxcOYoNbXYxEHk8ce0OHnLd');
              }
            }
          },
          {
            title: '全托管服务',
            text: '',
            list: [
              'AIPilot软件单机版',
              'AIPilot软件集群版',
              '大模型套餐包',
              '服务器及运维托管'
            ],
            image: Image_2,
            btn: {
              name: '预约咨询',
              click: () => {
                $Store.Page().openModal('modalFormCollection', 'demoCustomerCases')
              }
            }
          },
          {
            title: 'SaaS服务',
            text: '：',
            list: [
              '应用云部署时长',
              '按次套餐'
            ],
            image: Image_3,
            btn: {
              name: '立即体验',
              click: () => {
                // location.href = $Config.Href.store;
                open($Config.Href.store);
              }
            }
          }
        ]
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/home/';

.case {
  overflow: hidden;
  position: relative;
  z-index: 0;
  width: 100%;
  padding: 0 @padding;
  background-color: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
    .bg('@{image}case_bg.png', 100%, auto);
    background-position: top center;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

.ant-row {
  margin: @margin 0 0;
}

.item {
  @style: transform @time, box-shadow @time;
  overflow: hidden;
  position: relative;
  max-width: 380px;
  min-height: 400px;
  margin: 0 auto;
  background-color: @color_white;
  border-radius: 20px;
  .shadow(0 15px 25px fade(#6E778B, 30));
  .transition(@style);
  
  &:hover {
    .transform(translateY(-5px));
    .shadow(0 15px 25px fade(#6E778B, 40));
  }
  
  .loop(@i) when (@i<=3) {
    &.i_@{i} {
      .image {
        .bg('@{image}case_image_@{i}_bg.png', auto, 100%);
        background-repeat: repeat-x;
      }
    }
    .loop(@i+1);
  }
  .loop(1);
  
  .image {
    position: relative;
    height: 150px;
    
    img {
      display: block;
      .position();
      max-width: 100%;
      max-height: 90%;
      margin: auto;
    }
  }
  
  h5.ant-typography {
    padding: 0 @padding;
    margin: 20px 0 0;
    .font(center, @text_big, @color_12, @text_big, true);
  }
  
  div.ant-typography {
    height: (@text+@line)*2;
    padding: 0 @padding;
    margin: 10px 0 0;
    .font(justify, @text+@line, @color_13, @text);
  }
  
  .list {
    min-height: 120px;
    padding: 0 @padding;
    margin: 10px 0 0;
    .font(center, @text+@line, @color_13, @text);
    
    p {
      position: relative;
      // padding-left: 15px;
      margin: 0 0 5px;
      
      // &::before {
      //   content: '';
      //   display: block;
      //   .position(absolute, 10px, auto, auto, 0);
      //   width: 4px;
      //   height: 4px;
      //   background: @color_6;
      //   border-radius: 50%;
      // }
    }
  }
  
  .ant-space {
    margin: 15px auto;
    
    .button_n_3 {
      @ah: 40px;
      height: @ah !important;
      line-height: -4px+@ah !important;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .case {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  .ant-row {
    margin: @margin_mo 0 0;
  }
  
  .item {
    min-height: auto;
    
    h5.ant-typography {
      height: auto;
      .font(center, @text_big_mo, @color_12, @text_big_mo, true);
    }
    
    div.ant-typography {
      height: auto;
    }
    
    .list {
      min-height: auto;
    }
  }
}
</style>